// extracted by mini-css-extract-plugin
module.exports = {"goods-order-states":"goods-order-states-819377b1187c95705e8fef9ea20c64ac"};